<template>
    <v-container  v-if="$route.name === 'AdminPage'">
      <v-card>
        <v-card-title class="title subprimary">Управление классификаторами системы
          <v-spacer></v-spacer>
        </v-card-title>
        <v-layout wrap>
          <v-flex lg6>
          <v-card-title>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListLanguage')"><strong>Защищаемые языки</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListScientific_specialty')"><strong>Научные специальности</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam( 'ListAcademic_degree')"><strong>Ученые степени</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListAcademic_rank')"><strong>Учёные звания</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListOrganization')"><strong>Организации</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListScientific_industry')"><strong>Отрасли науки</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListScientific_field')"><strong>Научные специальности по отраслям науки</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListPerson')"><strong>Лица</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListPerson_academic_degree')"><strong>Учёные степени лица (по отраслям науки)</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left" v-if="isAdmin()">
              <router-link  :to="getRouteParam('ListRole')"><strong>Настройки ролей</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left" v-if="isAdmin()">
              <router-link  :to="getRouteParam('ListTokenRole')"><strong>Настройки внешних ролей</strong>  </router-link>
            </v-card-text>
          </v-card-title>
          </v-flex>

          <v-flex lg6>
          <v-card-title>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListDissertation_council')"><strong>Диссертационные советы</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListDissertation_council_scientific_field')"><strong>Научные специальности и отрасли науки привязанные к диссертационному совету</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListDissertation_council_member')"><strong>Члены диссертационных советов</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListCandidate_case')"><strong>Аттестационные дела соискателей</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListReview_opponent')"><strong>Отзывы оппонентов</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListReview_organization')"><strong>Отзывы ведущей организации</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListReview_person')"><strong>Cторонние отзывы</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListScientific_boss')"><strong>Отзывы научных руководителей</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListScientific_consultant')"><strong>Отзывы научных консультантов</strong>  </router-link>
            </v-card-text>
            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListDocTemplate')"><strong>Шаблоны документов</strong>  </router-link>
            </v-card-text>

            <v-card-text class="title text-xs-left">
              <router-link  :to="getRouteParam('ListStatus_history')"><strong>История статусов</strong>  </router-link>
            </v-card-text>
          </v-card-title>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  <div v-else>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
  import {isAdminPermission} from "../../../../helper";
    export default {
        name: "AdminPage",
        created() {
            this.$store.commit('mainpage/changeTitle', 'Администрирование');
        },
        methods:{
          isAdmin(){
            return  isAdminPermission()
          },
          getRouteParam(name){

            let paramR = {name: name}
            if(this.$route.params.token){
              paramR = {name: name, params:{token:this.$route.params.token}}
            }
            return paramR
          }
        }
    }
</script>

<style scoped>

</style>
